module.exports = __webpack_public_path__ + "static/media/riskScoreTwo.6e7417e0.mp3";